import { IMissingInfoFilters } from '../../../types'

export const addMissingInfoFilter = (
  selectedFilters: IMissingInfoFilters[],
  filterToAdd: IMissingInfoFilters
): IMissingInfoFilters[] => {
  if (filterToAdd === IMissingInfoFilters.any) {
    return [IMissingInfoFilters.any]
  }

  if (selectedFilters.includes(IMissingInfoFilters.any)) {
    return [...selectedFilters.filter(filter => filter !== IMissingInfoFilters.any), filterToAdd]
  }

  return [...selectedFilters, filterToAdd]
}
